export default __webpack_public_path__ + "static/media/Adobe_InDesign_Icon.ab55bd00.svg";